import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from '../../shared/list';

import { Tide } from '../../_models/tide';
import { TideService } from '../../_services/tide.service';
import { TideFilter } from '../../_models/tide';

@Component({
  selector: 'app-tides',
  templateUrl: './tide-list.component.html',
  styleUrls: ['./tide-list.component.sass'],
})
export class TideListComponent extends List implements OnInit {
  errorMessage: string;
  filter: TideFilter = new TideFilter();
  public isSelectAll = false;

  constructor(private tideService: TideService, private router: Router, private route: ActivatedRoute) {
    super(tideService, new Tide(), router, route);
  }

  checkForUpdate(event, tide, status) {
    event.preventDefault();
    this.tideService.requestForUpdate(tide.id, status).subscribe(
      (response) => {
        tide.update_requested = response.update_requested;
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public selectAll() {
    this.collection.forEach((tide) => {
      event.preventDefault();
      this.tideService.requestForUpdate(tide.id, !this.isSelectAll).subscribe(
        (response) => {
          tide.update_requested = response.update_requested;
        },
        (error) => this.httpErrorHandler.handleHttpError(error)
      );
    });
    this.isSelectAll = !this.isSelectAll;
  }

  ngOnInit() {
    this.initList('tides', this.filter);
  }
}



// WEBPACK FOOTER //
// ./src/app/tides/tide-list/tide-list.component.ts